import { Logo } from '@/components/icons';
import { ChevronDownIcon } from '@/components/icons/ChevronDownIcon';
import { SidebarHeaderProps } from './types';

export const SidebarHeader = ({ isCollapsed, onToggle }: SidebarHeaderProps) => {
  return (
    <div className={`${isCollapsed ? 'flex justify-center max-h-fit' : 'min-h-16'} flex items-center transition-[min-height] duration-300 ease-in-out`}>
      {isCollapsed ? (
        <button onClick={onToggle} className="p-1 text-white hover:bg-menu-hover/40 rounded transition-colors">
          <div className="transform rotate-[-90deg] transition-transform duration-150 hover:scale-110">
            <ChevronDownIcon className="w-7 h-7 text-white" />
          </div>
        </button>
      ) : (
        <div className="flex items-center justify-between w-full animate-fadeIn">
          <Logo />
          <button onClick={onToggle} className="p-1 text-white hover:bg-menu-hover/40 rounded transition-colors">
            <div className="transform rotate-90 transition-transform duration-150 hover:scale-110">
              <ChevronDownIcon className="w-7 h-7 text-white" />
            </div>
          </button>
        </div>
      )}
    </div>
  );
};
